module.exports = __webpack_public_path__ + "view/img/logindi.29f577e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shj/logindi.png
// module id = ITcS
// module chunks = 19